import { makeMutationHook, makeQueryHook } from "utils/apolloUtils";

import {
  DISCOUNT_CODE_CREATE_MUTATION,
  DISCOUNT_CODE_DELETE_MUTATION,
  DISCOUNT_CODE_UPDATE_MUTATION,
} from "./mutations";
import {
  DiscountCodeCreate,
  DiscountCodeCreateVariables,
} from "./__generated__/DiscountCodeCreate";
import { DISCOUNT_CODES_QUERY, DISCOUNT_CODE_QUERY } from "./queries";
import {
  DiscountCodes,
  DiscountCodesVariables,
} from "./__generated__/DiscountCodes";
import {
  DiscountCodeDelete,
  DiscountCodeDeleteVariables,
} from "./__generated__/DiscountCodeDelete";
import {
  DiscountCodeQuery,
  DiscountCodeQueryVariables,
} from "./__generated__/DiscountCodeQuery";
import {
  DiscountCodeUpdate,
  DiscountCodeUpdateVariables,
} from "./__generated__/DiscountCodeUpdate";

export const useDiscountCodeCreateMutation = makeMutationHook<
  DiscountCodeCreate,
  DiscountCodeCreateVariables
>(DISCOUNT_CODE_CREATE_MUTATION);

export const useDiscountCodeUpdateMutation = makeMutationHook<
  DiscountCodeUpdate,
  DiscountCodeUpdateVariables
>(DISCOUNT_CODE_UPDATE_MUTATION);

export const useDiscountCodeDeleteMutation = makeMutationHook<
  DiscountCodeDelete,
  DiscountCodeDeleteVariables
>(DISCOUNT_CODE_DELETE_MUTATION);

export const useDiscountCodesQuery = makeQueryHook<
  DiscountCodes,
  DiscountCodesVariables
>(DISCOUNT_CODES_QUERY);

export const useDiscountCodeQuery = makeQueryHook<
  DiscountCodeQuery,
  DiscountCodeQueryVariables
>(DISCOUNT_CODE_QUERY);
